import request from "@/utils/request"
// 充电订单
export function GetDevChargeOrderPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevChargeOrderPageList",
    method: "post",
    data
  })
}
// 设备故障
export function GetDevFaultPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevFaultPageList",
    method: "post",
    data
  })
}
//分页查询微信用户
export function GetJngWxUserPageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/JngWxUser/GetPageList",
    method: "get",
    params
  })
}

//设备状态功率曲线
export function GetPlatFormHisList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetPlatFormHisList",
    method: "post",
    data
  })
}
//用户曲线
export function GetAcHisList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetAcHisList",
    method: "post",
    data
  })
}

// 智能托管有序充电订单详情中的托管计划
export function getDevChargeOrderSubListApi(params) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevChargeOrderSubList",
    method: "get",
    params
  })
}